export default "__VITE_ASSET__3830151e__"